import withLandingPageProps from '../../lib/withLandingPageProps';
import LoggedOutLogoMaker from '../LoggedOutLogoMaker';
import './index.scss';

/**
 * @param {HeaderProps} props
 * @returns {React.ReactElement} Header
 */
export default withLandingPageProps(LoggedOutLogoMaker);
